import {
  State,
  VariablesEditorAction,
  CHANGE_VALUE,
  RESET,
  APPLY_STATE_FROM_INPUT,
  SET_SEARCH,
  SET_TYPE_FILTER,
  SET_CATEGORY_FILTER,
  SET_SHOW_VARIABLE_ID_STRING,
  initialSate,
} from '.';
import { assocPath, dissocPath } from 'ramda';

export const stateReducer = (state: State = initialSate, action: VariablesEditorAction): State => {
  switch (action.type) {
    case CHANGE_VALUE:
      return assocPath(['variables', action.payload.id], action.payload.value, state);
    case RESET:
      return dissocPath(['variables', action.payload.id], state);
    case APPLY_STATE_FROM_INPUT:
      return { ...action.payload.state, typeFilter: state.typeFilter, categoryFilter: state.categoryFilter };
    case SET_SEARCH:
      return assocPath(['search'], action.payload.value, state);
    case SET_TYPE_FILTER:
      return assocPath(['typeFilter'], action.payload.value, state);
    case SET_CATEGORY_FILTER:
      return assocPath(['categoryFilter'], action.payload.value, state);
    case SET_SHOW_VARIABLE_ID_STRING:
      return assocPath(['showVariableIDString'], action.payload.value, state);
    default:
      return state;
  }
};
